import {MOBILE_QUERY} from "js/constants"
import {closeMenu, removeTrainsition} from "./main-nav"

const handleMobileChange = (mediaQueryList: MediaQueryListEvent | MediaQueryList) => {
  if (mediaQueryList.matches) return // its mobile
  removeTrainsition()
  closeMenu()
}

MOBILE_QUERY.addEventListener("change", handleMobileChange)
